import React from 'react'
import behead from 'remark-behead'
import { withPrefix } from 'gatsby'
import _ from 'lodash'
import visit from 'unist-util-visit'
import map from 'unist-util-map'
import MDX from '@aitodotai/mdx-js-runtime'
import { InlineMath, BlockMath } from 'react-katex'
import Code from './Code'
import Mermaid from './Mermaid'
import { Alert } from '..'
import * as styles from './styles'

const STATIC_PREFIX = '/static/'

// Shifting heading level allows us to write parts of documentation without knowing how much the
// correct level of heading should be in the context of where the part is injected into
export default function Markdown({ children, ast, shiftHeadingLevel = 0 }) {
  // Provide custom components that will be referenced as JSX
  // in the markdown string
  const scope = {
    Alert,
    Mermaid,
    InlineMath,
    BlockMath
  }

  const components = {
    code: Code
  }

  const mdPlugins = [
    [behead, { depth: shiftHeadingLevel }],
  ]
  const hastPlugins = [
    // https://github.com/mdx-js/mdx/issues/370
    () => tree => visit(tree, 'element', (node) => {
      if (node.tagName !== 'code') {
        return
      }
      const { value } = node.children[0]

      // Double escape backward slashes
      node.children[0].value = value.replace(/\\/g, '\\\\')
    }),

    // Converts images with references to /static/ to have correct src property
    () => tree => visit(tree, 'element', (node) => {
      if (node.tagName !== 'img') {
        return
      }

      // Trying to find for example /static/venn-diagram.svg
      if (_.isString(node.properties.src) && _.startsWith(node.properties.src, STATIC_PREFIX)) {
        // Transforming it to /venn-diagram.svg
        const src = node.properties.src.slice(STATIC_PREFIX.length - 1)
        // Getting the correct prefix from gatsby

        node.properties.src = withPrefix(src)
      }
    }),

    // Transforms code blocks with mermaid lang to divs
    () => tree => map(tree, (node) => {
      if (node.tagName !== 'pre') {
        return node
      }

      const hasChildren = _.isArray(node.children) && node.children.length === 1
      if (hasChildren && node.children[0].tagName === 'code') {
        const child = node.children[0]
        const isMermaid = _.includes(child.properties.className, 'language-mermaid')
        if (isMermaid) {
          return {
            type: 'element',
            tagName: 'div',
            properties: {
              className: ['div'],
            },
            children: [{
              type: 'text',
              value: child.children[0].value,
            }]
          }
        }
      }

      return node
    })
  ]

  return (
    <styles.Container>
      <MDX
        scope={scope}
        components={components}
        mdPlugins={mdPlugins}
        hastPlugins={hastPlugins}
        // Performance hit but needed to not modify the original object
        // Multiple renders causes e.g. behead to shift the header level again
        mdxast={_.cloneDeep(ast)}
      >
        {children}
      </MDX>
    </styles.Container>
  )
}
